interface Props {
  fill?: string;
  size?: number;
}

const Phone = ({ fill = '#FD7E14', size = 12 }: Props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 12 12' fill='none'>
    <g id='call'>
      <mask id='mask0_1975_37498' maskUnits='userSpaceOnUse' x='0' y='0' width='12' height='12'>
        <rect id='Bounding box' width='12' height='12' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_1975_37498)'>
        <path
          id='call_2'
          d='M10.3542 11C9.19676 11 8.05324 10.7477 6.92361 10.2431C5.79398 9.73843 4.7662 9.02315 3.84028 8.09722C2.91435 7.1713 2.19907 6.14352 1.69444 5.01389C1.18981 3.88426 0.9375 2.74074 0.9375 1.58333C0.9375 1.41667 0.993056 1.27778 1.10417 1.16667C1.21528 1.05556 1.35417 1 1.52083 1H3.77083C3.90046 1 4.0162 1.04398 4.11806 1.13194C4.21991 1.21991 4.28009 1.32407 4.29861 1.44444L4.65972 3.38889C4.67824 3.53704 4.67361 3.66204 4.64583 3.76389C4.61806 3.86574 4.56713 3.9537 4.49306 4.02778L3.14583 5.38889C3.33102 5.73148 3.55093 6.0625 3.80556 6.38194C4.06019 6.70139 4.34028 7.00926 4.64583 7.30556C4.93287 7.59259 5.2338 7.8588 5.54861 8.10417C5.86343 8.34954 6.19676 8.57407 6.54861 8.77778L7.85417 7.47222C7.9375 7.38889 8.0463 7.32639 8.18056 7.28472C8.31482 7.24306 8.44676 7.23148 8.57639 7.25L10.4931 7.63889C10.6227 7.67593 10.7292 7.74306 10.8125 7.84028C10.8958 7.9375 10.9375 8.0463 10.9375 8.16667V10.4167C10.9375 10.5833 10.8819 10.7222 10.7708 10.8333C10.6597 10.9444 10.5208 11 10.3542 11Z'
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

export default Phone;
